<template>
  <div class="header-logo tw-flex tw-h-full">
    <default-header-logo-iu class="iu-logo tw-h-full" />
    <v-img src="https://igws.indiana.edu/images/IGWS_Logo.svg" max-width="140" contain class="tw-ml-4" />
  </div>
</template>

<script>
import DefaultHeaderLogoIu from './DefaultHeaderLogoIu'
export default {
  name: 'DefaultHeaderLogo',
  components: { DefaultHeaderLogoIu }
}
</script>

<style scoped>
</style>
